<template>
  <v-card
    class="mx-auto EK-card IMThemeGray rounded-xl rounded-tr-0 overflow-hidden text-right pb-5"
  >
    <v-card-title class="justify-content-center text-white">
      <strong>إرسال رسالة لجميع المتاجر</strong>
    </v-card-title>
    <v-form @submit.prevent="submitForm" ref="sendMessage" v-model="valid">
      <v-card-text class="pb-0">
        <v-col>
          <v-row>
            <v-col cols="12">
              <label for="description">
                <img
                  src="/media/svg/document-notification.svg"
                  width="24"
                  class="ml-2"
                  alt="pen"
                />
                نص الرسالة
              </label>
              <v-textarea
                v-model="broadcastDto.message"
                class="rounded-tr-0"
                color="secondary"
                id="description"
                :rules="messageRule"
                rounded
                solo
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
      </v-card-text>
      <v-card-actions class="justify-content-center">
        <v-btn type="submit" :disabled="!valid" class="by-5 px-10 rounded-tr-0">
          إرسال وتصدير
        </v-btn>

        <v-btn
          type="button"
          outlined
          color="error"
          class="by-5 px-10 rounded-tr-0"
          @click="close"
        >
          إلغاء
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    valid: false,
    message: "",
    shopIds: [],
    messageRule: [(v) => !!v || "يرجى إدخال نص الرسالة"],
  }),
  created() {},
  computed: {
    ...mapGetters(["broadcastDto", "filterdShopList"]),
  },
  methods: {
    ...mapActions(["broadcastMessage"]),
    close() {
      this.$emit("close");
      this.$refs.sendMessage.reset();
    },
    submitForm() {
      this.filterdShopList.forEach((shop) => {
        this.broadcastDto.shopIds.push(shop.id);
      });
      this.broadcastMessage(this.broadcastDto).then(() => {
        this.exportToExcel(this.shopNumbers);
      });
      this.close();
    },
    
  },
};
</script>
